import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import { CONTEXT_POST_VALIDER_ACQUISITION_MATERIEL } from '../../constants/apiUrls.constants';

const materiel = combineReducers({
    validerAcquisition: APIReducer.bind(null, CONTEXT_POST_VALIDER_ACQUISITION_MATERIEL),
});

export default materiel;
